<template>
    <div>
        <template v-if="mkey == 'habilitado_Pedidos' || mkey == 'activar_Presupuesto'">
            <CRow class="mt-4 mx-2">
                <span class="text-muted font-weight-bold text-capitalize">{{ label }}</span>
                <CSwitch 
                    class="align-middle mx-2"
                    color="dark"
                    shape="pill"
                    :label="label"
                    @update:checked="nvalue => this.$emit('update-data', [mkey, nvalue ? 'V' : 'F'])"
                    :checked.sync="localValue"/>
            </CRow>
        </template>
        <template v-else-if="(mkey == 'estado')">
            <CRow class="mt-4 mx-2">
                <span class="text-muted font-weight-bold text-capitalize">{{label}} </span>
                <CSwitch 
                    class="align-middle mx-2"
                    color="dark"
                    shape="pill"
                    required
                    :label="label"
                    @update:checked="nvalue => this.$emit('update-data', [mkey, nvalue ? 'A' : 'I'])"
                    :checked.sync="localValue"/>
                <span class="font-italic"> {{ localValue ? " Activo" : " Inactivo" }}</span>
            </CRow>
        </template>
        <template v-else-if="(mkey == 'ciudad') || (mkey == 'establecimiento') || (mkey == 'tipo_Telefono')">
        </template>
        <template v-else>
            <CInput
                v-if="inRequiredGroup"
                :label="label"
                :type="mType"
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :value.sync="localValueInput"
                :required="inRequiredGroup"
                :isValid="!inRequiredGroup || validInput"
                @update:value="nvalue => this.$emit('update-data', [mkey, nvalue])">
            </CInput>
            <CInput
                v-if="!inRequiredGroup"
                :label="label"
                :type="mType"
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :value.sync="localValueInput"
                @update:value="nvalue => this.$emit('update-data', [mkey, nvalue])">
            </CInput>
        </template>
    </div>
</template>

<script>
export default {
    name: 'DependencyDynamicInput',
    data(){
        return {
            localValue: false,
            localValueInput: ''
        }
    },
    props: {
        mkey: String,
        label: String,
        value: String,
        requiredGroup: Array,
        type: String
    },
    mounted(){
        if (this.mkey == 'estado') {
            // console.log(this.value)
            this.value = this.value.length == 0 ? "I" : this.value
            this.localValue = this.value == "A"
        } else if(this.mkey == 'habilitado_Pedidos' || this.mkey == 'activar_Presupuesto') {
            // console.log(this.value)
            this.value = this.value.length == 0 ? "F" : this.value
            this.localValue = this.value == "V"
        } else {
            // console.log(this.value)
            this.localValueInput = this.value
        } 
    },
    watch: {
        value(){
            // console.log(this.value)
            if (this.mkey == 'estado') {
                // console.log(this.value == 'A')
                this.localValue = this.value == 'A'
            } else if(this.mkey == 'habilitado_Pedidos' || this.mkey == 'activar_Presupuesto') {
                this.localValue = this.value == 'V'
            } else {
                this.localValueInput = this.value
            }
        },
        
    },
    computed:{
        inRequiredGroup(){
            return this.requiredGroup.includes(this.mkey)
        },
      mType(){
        return this.type ? this.type : 'text'
      },
      validInput() {
          if (this.mType == 'email') {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.localValueInput);
          } else {
            return (this.localValueInput.length > 0)
          }
      }
    }
}
</script>